import { IBQuestionType } from "./ib-question-type";

export class IBQuestion {

	uuid: string;
	question: string;
	type?: IBQuestionType;
	answerSize?: number;
	integerAnswer?: number;
	decimalAnswer?: number;

	constructor(uuid: string, question: string, type: IBQuestionType, answerSize: number, integerAnswer?: number, decimalAnswer?: number) {
		this.uuid = uuid;
		this.question = question;
		this.type = type;
		this.answerSize = answerSize;
		this.integerAnswer = integerAnswer;
		this.decimalAnswer = decimalAnswer;
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/autentication/models/ib-question.ts